import * as DOMPurify from 'isomorphic-dompurify'

export default {
    install(Vue) {
        Vue.prototype['$sanitizer'] = {
            /**
             * Parse a html string to prevent possible XSS attacks.
             * @param {string} unparsed
             * @returns unparsed
             */
            sanitizeHtml(unparsed) {
                return DOMPurify.sanitize(unparsed)
            },
        }
    },
}